module.exports = __webpack_public_path__ + "static/media/controlSales.46bfca54.jpg";